import { AxiosError } from 'axios'

/** Extract a human-readable message from an API/axios error. */
export function apiError(err: unknown, fallback = 'Something went wrong'): string {
  if (err instanceof AxiosError) {
    const detail = err.response?.data?.detail
    if (typeof detail === 'string') return detail
    if (err.response?.status === 401) return 'Please sign in to continue'
    if (err.response?.status === 403) return 'You do not have permission to do that'
    return err.message
  }
  if (err instanceof Error) return err.message
  return fallback
}
